<template>
  <component
    :is="comSubTypeList[comSubType]"
    :refreshPeriod="refreshPeriod"
    ref="nav"
  ></component>
</template>

<script>
/*
   * 基本echart，柱状图，折线图以及饼图
   * */
import listNav from './list-nav'
import cardNav from './card-nav'
export default {
  name: 'navigation',
  props: {
    comSubType: {
      type: String,
      default: ''
    },
    refreshPeriod: {
      // 部件刷新周期
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      comSubTypeList: {
        full: 'listNav',
        card: 'cardNav'
      }
    }
  },
  components: {
    listNav,
    cardNav
  },
  methods: {
    initCardStyle () {
      this.$refs.nav.initCardStyle()
    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
@import "~assets/styles/var.less";
@import "~assets/styles/mixin.less";
</style>
